import PropTypes from 'prop-types';
import React from 'react';
import GenericFormItem from '../GenericFormItem';

const TextLabel = function TextLabel(props) {
  const {
    val,
    label,
  } = props;
  return (
    <GenericFormItem label={label}>
      {val}
    </GenericFormItem>
  );
};

TextLabel.propTypes = {
  val: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
};

export default TextLabel;



// WEBPACK FOOTER //
// ./src/components/FormConfigs/TextLabel.js